import React, { useState, useEffect } from 'react';
import { Avatar, Spin } from 'antd';
import { systemSettingsAPI, SystemSettings } from '../services/systemSettingsAPI';

interface SystemLogoProps {
  size?: 'small' | 'default' | 'large' | number;
  className?: string;
  showName?: boolean;
  selectedCompany?: any; // Seçilmiş şirkət
}

const SystemLogo: React.FC<SystemLogoProps> = ({ 
  size = 'default', 
  className = '',
  showName = false,
  selectedCompany = null
}) => {
  const [settings, setSettings] = useState<SystemSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const response = await systemSettingsAPI.getSettings();
      if (response.success && response.settings) {
        setSettings(response.settings);
      }
    } catch (error) {
      console.error('Logo loading error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Spin size="small" />;
  }

  const logoSize = typeof size === 'number' ? size : 
    size === 'small' ? 32 : 
    size === 'large' ? 64 : 40;

  // Prioritet: Şirkət logosu > Sistem logosu > Default hərf
  const logoUrl = selectedCompany?.logo_url || settings?.logo_url;
  const displayName = selectedCompany?.name || settings?.system_name;
  const fallbackLetter = displayName?.charAt(0) || 'C';

  return (
    <div className={`flex items-center ${className}`}>
      <Avatar
        size={logoSize}
        src={logoUrl}
        className="flex-shrink-0"
        style={{ 
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {!logoUrl && fallbackLetter}
      </Avatar>
      
      {showName && displayName && (
        <span className="ml-2 font-medium text-gray-900 truncate">
          {displayName}
        </span>
      )}
    </div>
  );
};

export default SystemLogo;